<template>
  <div>
    <LfBlueTitleComponent :title="TEXT.title" />
    <LfSimpleProgressBarComponent :text="TEXT.caption" />
    <div class="note-text">{{TEXT.note}}</div>
  </div>
</template>

<script setup lang="ts">
import { inject, onMounted } from 'vue'
import LfBlueTitleComponent from '@/components/HeaderTitle/LfBlueTitleComponent.vue'
import LfSimpleProgressBarComponent from '@/components/ProgressBar/LfSimpleProgressBarComponent.vue'
import { useI18n } from 'vue-i18n-composable'
import {
  useImportExpedientsProcessStore
} from '@/views/Expedients/components/ImportExpedientsDialog/stores/useImportExpedientsProcessStore'

const { t } = useI18n()
const nextStep = inject('nextStep') as () => void
const importExpedientsProcessStore = useImportExpedientsProcessStore()

const TEXT = {
  title: t('components.expedient_import_dialog.title').toString(),
  caption: t('components.expedient_import_dialog.loading.caption').toString(),
  note: t('components.expedient_import_dialog.loading.note').toString()
}

onMounted(async () => {
  try {
    await importExpedientsProcessStore.executeExpedientImport()
  } catch (error){
    console.log('Error', {error})
  } finally {
    nextStep()
  }
})

</script>

<style scoped lang="scss">
.note-text {
  @include inter-regular-14;
  color: $neutral-grey-700;
  margin-bottom: $spacing-md;
  margin-left: 8px;
  line-height: 22px;
  align-self: stretch;
  margin-top: $spacing-md;
}
</style>
